import * as React from 'react';
import * as Glob from '../Globale';
import { Redirect } from 'react-router-dom';

export class Logout extends React.Component<Glob.IRouteGlobaleProps, {}> {
    constructor(props: any) {
        super(props);

        var M = Glob.GetMenu();
        M.Main = "";
        this.props.SetMenu(M);
        this.props.SetSessione(new Glob.CSessione());
    }

    public render() {
        return <Redirect to="/" />;
    }
}



// WEBPACK FOOTER //
// ./src/form/Logout.tsx